import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, List } from '.';
import { combineStates, screenState, viewsState, viewSettingsState, screenSizeState, combineDispatchers, currentCartItemDispatcher } from '../store';
import { PropTypes } from 'prop-types';
import { ScreenType } from '../model';

export class GenericViewerComponent extends Component {
  constructor() {
    super();
    this.state = {
      viewType: 'grid',
      screenType: 'desktop',
      matchingView: 'simple'
    };
  }
  componentDidMount() {
    this.setView( this.props );
  }

  componentDidUpdate( prevProps ) {
    ['screen', 'views', 'view'].some( v => prevProps[v] !== this.props[v]) && this.setView( this.props );
  }

  setView( props ) {
    const { parentLayoutType, screen, view, views, viewSettings } = props;
    const screenType = ScreenType.getScreenType( screen, viewSettings[view] );
    let matchingView = parentLayoutType || views && views[view];
    if(view==="searchproduct" || view==="searchproductunavailable" || this.props.className==="mobile-grid-view" || this.props.screenSize.width<=900){
      matchingView = "simple"
    }

    if ( !matchingView || 
         this.state.viewType === matchingView && this.state.screenType === screenType || 
         !viewSettings[view] || 
         !viewSettings[view][screenType] ) {
      return;
    }

    if ( !viewSettings[view][screenType][matchingView] ) {
      matchingView = Object.keys( viewSettings[view][screenType] ).first();
      if(view==="searchproduct" || view==="searchproductunavailable"){
        matchingView = "simple"
      }
      if ( this.state.viewType === matchingView ) {
        return;
      }
    }

    this.setState( { 
      screenType, 
      viewType: matchingView, 
      layout: viewSettings[view][screenType][matchingView]
    } )
  }

  getCustomLayout = viewType => {
    const { view, viewSettings } = this.props;
    const { screenType } = this.state;
    return viewSettings[view][screenType][viewType];
  }

  getComponentType( matchingView ) {
    return matchingView === 'list' ? List : Grid;
  }
  
  render() {
    const { 
      detailTemplate, 
      footer, 
      isExpandable, 
      items, 
      noItemsFound, 
      onScroll, 
      onFilterChanged,
      fromModelConfigurator, 
      currentNode,
      unsetRequiredVariables,
      predicate,  
      template, 
      useCustomLayout,
      view ,
      className,
      cartActionsButton,
      NSTbom_ACC
    } = this.props;
    const Footer = footer;
    const { viewType, screenType, layout } = this.state;
    const { showFullContent, defaultAmount } = currentNode?.customProperties || {};

    if( !viewType || !screenType || !layout ) {
      return null;
    }

    const genericViewerComponent = React.createElement( this.getComponentType( viewType ), { 
      key: "generic-viewer",
      onScroll,
      layout,
      getCustomLayout: this.getCustomLayout,
      predicate, 
      isExpandable,
      items,
      noItemsFound,
      detailTemplate,
      template,
      useCustomLayout,
      onFilterChanged,
      defaultAmount,
      fromModelConfigurator,
      currentNode,
      unsetRequiredVariables,
      view,
      className,
      cartActionsButton,
      showCartItemActions: this.props.showCartItemActions,
      isLoading:this.props.isLoading,
      currentSelector:this.props.currentSelector,
      currentView: this.props.currentView,
      fromModelConfiguratorSelector:this.props.fromModelConfiguratorSelector,
      NSTbom_ACC
    } );

    return footer ? [genericViewerComponent, <Footer key="generic-viewer-footer"/>] : genericViewerComponent;
  }
}

GenericViewerComponent.propTypes = {
  detailTemplate: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ), 
  footer: PropTypes.oneOfType( [PropTypes.node, PropTypes.func] ), 
  isExpandable: PropTypes.func,
  items: PropTypes.arrayOf( PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.object] ) ), 
  noItemsFound: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ),
  onScroll: PropTypes.func, 
  onFilterChanged: PropTypes.func,
  parentLayoutType: PropTypes.string,
  predicate: PropTypes.func, 
  screen: PropTypes.shape( {
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired
  } ),
  template: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ),
  useCustomLayout: PropTypes.func,
  view: PropTypes.string,
  views: PropTypes.shape( { } ),
  viewSettings: PropTypes.shape( {} )
};

export const GenericViewer = connect( combineStates( screenState, viewsState, viewSettingsState, screenSizeState ), combineDispatchers(currentCartItemDispatcher) )( GenericViewerComponent );
